export default __webpack_public_path__ + "404-blue.bb337711858b2c3baaf0ca73fdd8957c.lottie";